var map = {
	"./Avatar_1.png": 5916,
	"./Avatar_10.png": 2150,
	"./Avatar_2.png": 4125,
	"./Avatar_3.png": 7595,
	"./Avatar_4.png": 6296,
	"./Avatar_5.png": 2709,
	"./Avatar_6.png": 5470,
	"./Avatar_7.png": 5229,
	"./Avatar_8.png": 8229,
	"./Avatar_9.png": 5840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5590;